import { Accessor, createSignal, onCleanup } from 'solid-js';

export const useHover = (): {
  isHovered: Accessor<boolean>;
  ref(el: HTMLElement): HTMLElement;
} => {
  const [isHovered, setIsHovered] = createSignal(false);
  let element: HTMLElement | undefined;

  const onMouseEnter = (): void => {
    setIsHovered(true);
  };
  const onMouseLeave = (): void => {
    setIsHovered(false);
  };

  onCleanup(() => {
    if (element) {
      element.removeEventListener('mouseenter', onMouseEnter);
      element.removeEventListener('mouseleave', onMouseLeave);
    }
  });

  return {
    isHovered,
    ref: (el: HTMLElement) => {
      element = el;
      el.addEventListener('mouseenter', onMouseEnter);
      el.addEventListener('mouseleave', onMouseLeave);
      return el;
    },
  };
};
